export const dateToISO = (date: Date): string => {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    return `${year}-${month < 10 ? ('0' + month) : month}-${day < 10 ? ('0' + day) : day}`
}

export const cloneDate = (date: Date): Date => {
    return new Date(date)
}

export const resetDate = (date: Date): void => {
    date.setHours(0, 0, 0, 0)
}

export const iResetDate = (date: Date): Date => {
    const clone = cloneDate(date)
    resetDate(clone)
    return clone
}
